import React from "react";

//MUI
import SvgIcon from '@mui/material/SvgIcon';

//Types
import { SvgIconProps } from "@mui/material";

function PodrucjeNacionalniParkIcon(props: SvgIconProps) {
  return <SvgIcon {...props}>
    <svg version="1.1" id="PodrucjeNacionalniParkIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="100px" height="100px" viewBox="0 0 100 100"
      style={{
        //@ts-ignore
        enableBackground: "new 0 0 100 100"
      }}
      xmlSpace="preserve">
      <rect y="25.7" fill="#E3B4E7" width="100" height="50" />
      <rect y="24.3" fill="#DA5B9C" width="100" height="3" />
    </svg>
  </SvgIcon>
}

export default PodrucjeNacionalniParkIcon;
